import { config } from './config';
import { demoActive } from './modeDemo';

/**
 * URL de la photo d'un compte : celle de son compte Microsoft, lue par l'API
 * (DEC-037). Elle ne se tente que pour un compte qui entre par Microsoft
 * (`photoMicrosoft`) ; `UserAvatar` la précharge et garde les initiales si
 * elle n'arrive pas.
 */
export function avatarSrc(userId: string): string | undefined {
  // Les personnages de la démo n'ont pas de photo : les initiales, sans appel au réseau.
  if (demoActive()) return undefined;
  return `${config.API_BASE_URL}/users/${userId}/avatar`;
}
